import useFetchObjects from "../../api/useFetchObjects";

const useCategories = () => {
  return useFetchObjects(["categories"], "categories/", null, {
    refetchOnWindowFocus: false,
  });
};

export default useCategories;
